<template>
  <div id="contact-page">
    <div class="default-layout-container">
      <div class="content-container-1140">
        <div class="main-content">
          <h1>{{ $t(`navigation.routeTitles.contact`) }}</h1>
          <div
            class="page-content md-content"
            v-html="md.render(pageContent.data.attributes.ContactPageIntro)"
          ></div>
          <div class="contact-email-wrapper">
            <v-icon icon="$envelope"></v-icon>
            <a
              v-html="pageContent.data.attributes.ContactEmail"
              :href="`mailto:${pageContent.data.attributes.ContactEmail}`"
            ></a>
          </div>
          <ContactForm></ContactForm>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const { locale, t } = useI18n();
const { md } = useMarkdownIt();

useHead({
  title: t('navigation.routeTitles.contact')
})

// api content
const contentType = "contact";
const key = `${contentType}_${locale.value}`;

const apiURL = getStrapiLink(contentType);
const { data: pageContent } = await useFetch(apiURL, {
    key: key,
    watch: false,
  });
</script>
<style lang="scss" scoped>
#contact-page {
  .md-content {
    p {
      font-size: 24px;
    }

    a[href^="mailto:"] {
      position: relative;
      padding-left: 1.25em;
      font-size: 500 !important;

      &:before {
        content: "\f0e0" !important;
        font-family: "Font Awesome 6 Solid" !important;
        font-weight: 100 !important;
        position: absolute;
        left: 0;
        top: -1px;
        text-decoration: none;
        color: #050505;
      }
    }
  }
  .contact-email-wrapper {
    margin-bottom: 50px;

    i {
      margin-right: 10px;
      vertical-align: text-bottom;
    }
    a {
      font-size: 24px;
      font-weight: 500;
      color: #267a6c;
      text-decoration: underline;
      word-break: break-all;

      &:hover {
        text-decoration: underline dotted;
      }
    }
  }
}
</style>
